/**
 * Known tag keys delivered by the backend. The setting is the source of truth
 * for which columns render; these constants are only used to enforce the fixed
 * display order and to identify special-behavior tags (e.g. the group-drop date).
 */
export const INSTRUCTOR_LINK_TAG_KEYS = {
  assignmentDate: "itesm.mx/group_assignment_date",
  paymentStartDate: "itesm.mx/group_payment_start_date",
  paymentEndDate: "itesm.mx/group_payment_end_date",
  dropDate: "itesm.mx/group_drop_date",
  paymentEnabled: "itesm.mx/group_payment_enabled",
} as const;
